import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const requestGetSummary = (jobId, reportId) =>
    axios.get(`${apiUrl}summary?jobId=${jobId}&reportId=${reportId}`);

export const requestGetReportRanges = (jobId) =>
    axios.get(`${apiUrl}summary/reportRanges?jobId=${jobId}`);

export const requestGetIncomplete = (jobId, reportId) =>
    axios.get(`${apiUrl}summary/incomplete?jobId=${jobId}&reportId=${reportId}`);

export const requestGetExceptions = (jobId, reportId) =>
    axios.get(`${apiUrl}summary/exceptions?jobId=${jobId}&reportId=${reportId}`);

export const requestGetSummaryJobs = () =>
    axios.get(`${apiUrl}summary/jobs`);

export const requestGetExcel = (jobId, reportId) => axios.get(`${apiUrl}summary/export/excel?jobId=${jobId}&reportId=${reportId}`, {
    responseType: "blob"
});

export const requestGetCSV = (jobId, reportId) => axios.get(`${apiUrl}summary/export/csv?jobId=${jobId}&reportId=${reportId}`, {
    responseType: "blob"
});

export const requestFlaggedSummary = (reportId) =>
    axios.get(`${apiUrl}summary/flagged?reportId=${reportId}`);

export const requestReleaseAll = (filteredIdArr) => axios.patch(`${apiUrl}summary/releaseAll`, filteredIdArr);

export const requestReleaseSingle = (serviceId, released) =>
    axios.patch(`${apiUrl}summary/setIsReleased?serviceId=${serviceId}&isReleased=${released}`);

export const requestDisplayChartToClient = (reportId, displayCompletionChartToClient) =>
    axios.patch(`${apiUrl}summary/setDisplayChartToClient?reportId=${reportId}&status=${displayCompletionChartToClient}`);

export const requestUpdateReviewed = (serviceId, reviewed) =>
    axios.patch(`${apiUrl}summary/setReviewed?serviceId=${serviceId}&reviewed=${reviewed}`);

export const requestUpdateReviewed2 = (serviceId, reviewed) =>
    axios.patch(`${apiUrl}summary/setReviewed2?serviceId=${serviceId}&reviewed=${reviewed}`);

export const requestUpdateReleaseNotes = (serviceId, releaseNotes) =>
    axios.patch(`${apiUrl}summary/setReleaseNotes?serviceId=${serviceId}&releaseNotes=${releaseNotes}`);
